import evaluateProductModal from "./evaluateProductModal"
export default evaluateProductModal;
